import { Fragment, FunctionComponent, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "@App/state";
import { Body } from "@App/types";
import { useTranslation } from "react-i18next";
import { bindActionCreators } from "@reduxjs/toolkit";
import { BodyList } from "@App/Components/Vehicletree/BodyList";
import { Loader } from "@App/Components/Loader";
import { FunnelHeader } from "@App/Components/Funnel/FunnelHeader";

export type BodiesProps = {
  headline: string;
  step: number;
  maxSteps: number;
  onSubmit?: (body: Body) => void;
};

export const Bodies: FunctionComponent<BodiesProps> = ({
  headline,
  step,
  maxSteps,
  onSubmit,
}: BodiesProps) => {
  const { t } = useTranslation();
  const motorization = useSelector((state: State) => state.orders.motorization);
  const body = useSelector((state: State) => state.orders.body);

  const dispatch = useDispatch();
  const { chooseBody } = bindActionCreators(actionCreators, dispatch);

  const setBody = (body: Body): void => {
    chooseBody(body);
    onSubmit && onSubmit(body);
  };

  useEffect(() => {
    if (body) {
      return;
    }
    // set body if only one option available
    if (motorization && motorization?.bodies?.length === 1) {
      setBody(motorization.bodies[0]);
    }
    // set default body if no bodies available
    if (motorization && motorization?.bodies?.length === 0) {
      setBody({
        id: 1,
        name: "Standard",
      });
    }
  }, [motorization]);

  if (!motorization) {
    return (
      <div className="h-screen w-screen grid place-items-center">
        <Loader />
      </div>
    );
  }

  return (
    <Fragment>
      <div
        className="
                container bg-white
                pt-10 pb-12
                "
      >
        <FunnelHeader
          heading={headline}
          step={step}
          maxSteps={maxSteps}
          subheading={t("bodies.headline")}
        />
        <BodyList bodies={motorization.bodies ?? []} onClick={setBody} />
      </div>
    </Fragment>
  );
};
